
/**
toRad(deg)
**/

export default (n) => n * Math.PI / 180;
